import { LanguageCode } from '@shared/constants/language';
import useLanguage from '@shared/hooks/useLanguage';
import { useSnackbar } from '@shared/hooks/useSnackbar';
import { useTranslationHelper } from '@shared/hooks/useTranslationsHelper';
import {
  MdcBox,
  MdcIcon,
  MdcList,
  MdcListItem,
  MdcMenu,
  MdcMenuAnchor,
  MdcTypography
} from 'ids-wc/dist/react/components';
import { useEffect, useRef } from 'react';
import styles from './LanguageSwitcher.module.css';

interface LanguageSwitcherProps {
  changeUIOnly?: boolean;
}

const LanguageSwitcher = ({ changeUIOnly = false }: LanguageSwitcherProps) => {
  const { changeLanguage, i18nActiveLanguage, updateLoading, updateError } = useLanguage();
  const menuRef = useRef<HTMLMdcMenuElement>(null);
  const { showError } = useSnackbar();

  const { t } = useTranslationHelper('languages');

  const toggleMenu = () => {
    if (menuRef.current) {
      menuRef.current.open();
    }
  };

  const onLanguageChange = (lang: LanguageCode) => {
    changeLanguage(lang, changeUIOnly);
  };

  useEffect(() => {
    if (updateError) {
      showError(t('pleaseTryAgainLater'), t('unableToUpdateLanguage'));
    }
  }, [updateError, showError, t]);

  const containerStyles = `${styles['lang-switcher']} p-1`;
  return (
    <MdcMenuAnchor>
      <MdcBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        className={containerStyles}
        onClick={toggleMenu}
      >
        <MdcIcon size="md" color="secondary" title="language" icon="language" />
        <MdcTypography text={t(i18nActiveLanguage)} variant="caption" color="textPrimary" />
        <MdcIcon size="md" color="secondary" title="arrow-down" icon="arrow-down" />
      </MdcBox>
      <MdcMenu ref={menuRef}>
        {updateLoading ? (
          <MdcTypography text={t('wait')} variant="caption" color="textPrimary" />
        ) : (
          <MdcList>
            <MdcListItem text="En" value="english" onClick={() => onLanguageChange(LanguageCode.EN)} />
            <MdcListItem text="Ελ" value="greek" onClick={() => onLanguageChange(LanguageCode.GR)} />
          </MdcList>
        )}
      </MdcMenu>
    </MdcMenuAnchor>
  );
};

export default LanguageSwitcher;
